import React from 'react';
import { WYSIWYGRenderer } from '@vectord/components';
import { useSelector } from 'react-redux';

import {
  editCrashCourseBatchSelector,
  FUTURE_CLASSES_VISIBILITY_DATA,
  PAST_CLASSES_VISIBILITY_DATA,
  SCHEDULED_CLASSES_VISIBILITY_DATA,
  UPDATE_ACTIONS,
} from 'features/classCreation';
import AddLearnersButton from '../AddLearnersButton';
import ConfimModalCloseButton from '../ConfimModalCloseButton';
import RemoveLearnersButton from '../RemoveLearnersButton';
import styles from './ConfirmModalContent.module.scss';
import SuperBatchTypeChip from 'components/SuperBatchTypeChip';
import SuperBatchMenteeEmails from '../SuperBatchMenteeEmails';

const LEARNER_MODIFICATION_BUTTON_MAP = {
  [UPDATE_ACTIONS.add]: AddLearnersButton,
  [UPDATE_ACTIONS.remove]: RemoveLearnersButton,
};

function ConfirmModalContent() {
  const editCrashCourseBatch = useSelector(editCrashCourseBatchSelector);
  const {
    selectedSuperBatch,
    learnerEmails,
    pastClassesStatus,
    learnerUpdateAction,
    batchSequence,
    moduleRepeat,
  } = editCrashCourseBatch;
  const isAdd = learnerUpdateAction === UPDATE_ACTIONS.add;
  const fieldLabel = isAdd ? 'LEARNERS ADDED' : 'LEARNERS REMOVED';
  const LearnerModificationButton =
    LEARNER_MODIFICATION_BUTTON_MAP[learnerUpdateAction];
  const { batch_type: batchType } = selectedSuperBatch;
  const pastClassesLabel = PAST_CLASSES_VISIBILITY_DATA[learnerUpdateAction]?.[
    batchType
  ]?.find((data) => data.value === pastClassesStatus)?.label;

  if (selectedSuperBatch && learnerUpdateAction) {
    return (
      <>
        <div className="primary m-b-xs bold">CONFIRM CHANGES</div>
        <div className="m-b-xs">
          <div className="h5">BATCH</div>
          <div className="row">
            <span className="dark">{selectedSuperBatch?.label}</span>
            <SuperBatchTypeChip batchType={batchType} />
          </div>
        </div>
        <div className="m-b-xs">
          <div className="h5">{fieldLabel}</div>
          <SuperBatchMenteeEmails
            menteeEmails={learnerEmails}
            trimIfMany
          />
        </div>
        {batchSequence && (
          <div className="m-b-xs">
            <div className="h5">SEQUENCE</div>
            <div className="row">
              <span className="dark">{batchSequence}</span>
            </div>
          </div>
        )}
        <div className="m-b-xs">
          <div className="h5">MODULE REPEAT</div>
          <div className="row">
            <span className="dark">{moduleRepeat ? 'Yes' : 'No'}</span>
          </div>
        </div>
        <div className={styles.classes}>
          <div>
            <div className="h5 hint">PAST CLASSES</div>
            {pastClassesLabel}
          </div>
          <div>
            <div className="h5 hint">SCHEDULED</div>
            <WYSIWYGRenderer
              html={
                SCHEDULED_CLASSES_VISIBILITY_DATA[learnerUpdateAction][
                  batchType
                ]
              }
            />
          </div>
          <div>
            <div className="h5 hint">TO BE SCHEDULED</div>
            <WYSIWYGRenderer
              html={
                FUTURE_CLASSES_VISIBILITY_DATA[learnerUpdateAction][batchType]
              }
            />
          </div>
        </div>
        <div className="row">
          <LearnerModificationButton />
          <ConfimModalCloseButton />
        </div>
      </>
    );
  }
  return null;
}

export default ConfirmModalContent;
